import React, { useEffect } from 'react';
import { LandingComponent } from 'app/types';

interface PreviewComponentProps {
  landing_cmp: LandingComponent;
}

const HtmlInnerScriptPreview = ({ landing_cmp }: PreviewComponentProps): React.ReactElement => {
  useEffect(() => {
    if (landing_cmp.config.script) {
      const script = document.createElement('script');
      script.id = landing_cmp.html_id;
      script.textContent = landing_cmp.config.script;
      document.body.appendChild(script);
    }
    return () => {
      const script = document.getElementById(landing_cmp.html_id);
      if (script) document.body.removeChild(script);
    };
  }, []);
  return (
    <div
      id={landing_cmp.html_id}
      key={landing_cmp.id}
      style={{
        width: landing_cmp.size !== 'sm' && landing_cmp.size !== 'md' ? landing_cmp.size : 'auto',
        padding: landing_cmp.size === 'sm' ? '0 12rem' : '0 4vw',
        margin: landing_cmp.gap,
        background: !(landing_cmp.background instanceof File) ? landing_cmp.background : 'auto',
        backgroundSize: landing_cmp.background_size,
        backgroundImage: `url(${landing_cmp.background_image})`,
      }}
      className={landing_cmp.class_name}
    ></div>
  );
};

export default HtmlInnerScriptPreview;
